var m = Object.defineProperty;
var h = (r, o, c) => o in r ? m(r, o, { enumerable: !0, configurable: !0, writable: !0, value: c }) : r[o] = c;
var t = (r, o, c) => h(r, typeof o != "symbol" ? o + "" : o, c);
import { DocumentBuilder as i } from "./document-builder.js";
import { BlockParser as u } from "./block-parser.js";
class B {
  constructor(o) {
    t(this, "schema");
    this.schema = o;
  }
  parse(o, c) {
    const s = new i(this.schema), a = new u(s, c), e = o.blocks;
    return e.forEach((n, l) => {
      a.handle(n, e[l + 1]);
    }), s.doc;
  }
}
export {
  B as BlocksParser
};
